module Shared.Admin.Audit

open System

type AuditOperation = 
    | CreateUser = 1
    | UpdateUser = 2
    | LockUser = 3
    | UnlockUser = 4
    | DisableUser = 5
    | EnableUser = 6
    | CreateTag = 7
    | DeleteTag = 8
    | AddTagToUser = 9
    | RemoveTagFromUser = 10
    | AddApplicationAccess = 11
    | RemoveApplicationAccess = 12
    | ChangeApplicationAccessLevel = 13
    | ChangePassword = 14
    | UpdateArticle = 15
    | DeleteArticle = 16
    | PublishArticle = 17
    | UnpublishArticle = 18
    | CreateArticle = 19
    | ChangeEmailAddress = 20
    | ChangePhoneNumber = 21
    | UpdateMFAToken = 22
    | ResetMFAToken = 23

module AuditOperation =
    let format =
        function
        | AuditOperation.CreateUser -> "Create User"
        | AuditOperation.UpdateUser -> "Update User"
        | AuditOperation.LockUser -> "Lock User"
        | AuditOperation.UnlockUser -> "Unlock User"
        | AuditOperation.DisableUser -> "Disable User"
        | AuditOperation.EnableUser -> "Enable User"
        | AuditOperation.CreateTag -> "Create Tag"
        | AuditOperation.DeleteTag -> "Delete Tag"
        | AuditOperation.AddTagToUser -> "Add Tag to User"
        | AuditOperation.RemoveTagFromUser -> "Remove Tag From User"
        | AuditOperation.AddApplicationAccess -> "Add Application Access"
        | AuditOperation.RemoveApplicationAccess -> "Remove Application Access"
        | AuditOperation.ChangeApplicationAccessLevel -> "Change Application Access Level"
        | AuditOperation.ChangePassword -> "Change Password"
        | AuditOperation.UpdateArticle -> "Update Article"
        | AuditOperation.DeleteArticle -> "Delete Article"
        | AuditOperation.PublishArticle -> "Publish Article"
        | AuditOperation.UnpublishArticle -> "Unpublish Article"
        | AuditOperation.CreateArticle -> "Create Article"
        | AuditOperation.ChangeEmailAddress -> "Change Email Address"
        | AuditOperation.ChangePhoneNumber -> "Change Phone Number"
        | AuditOperation.UpdateMFAToken -> "Updated MFA Token"
        | AuditOperation.ResetMFAToken -> "Reset MFA Token"
        | _ -> "Unknown"

    let iterate() =
        [
            for i in 1..21 do
                yield enum<AuditOperation> i
        ]

type AuditEntry =
    {
        PerformedBy: string
        DateLogged: DateTime
        Message: string
    }

type AuditFilter =
    {
        From: DateTime
        To: DateTime
        Operations: AuditOperation list
        Username: string option
    }